export default {
  namespaced: true,
  state: {
    pdfLogoDataUrl: null,
    hasPdfLogo: false,
    loaded: false,
  },
  mutations: {
    setPdfLogoFromPayload(state, payload) {
      const hasLogo = !!(payload && payload.hasLogo);
      state.hasPdfLogo = hasLogo;
      if (hasLogo && payload.base64 && payload.mimeType) {
        state.pdfLogoDataUrl = `data:${payload.mimeType};base64,${payload.base64}`;
      } else {
        state.pdfLogoDataUrl = null;
      }
      state.loaded = true;
    },
    invalidatePdfLogo(state) {
      state.loaded = false;
    },
    reset(state) {
      state.pdfLogoDataUrl = null;
      state.hasPdfLogo = false;
      state.loaded = false;
    },
  },
};
